/* ==========================================================================
   MSearcherFlight > Client >  Prototype
   ========================================================================= */
// Modules
const { toNode } = require('@bluekiri/alexandria/helpers/domHelpers');
const PriceFormatter = require('@bluekiri/alexandria/core/PriceFormatter');
const { validationDestination } = require('./validation');
const { suscriptionDates } = require('./transactions');

const prototype = {
    // params: dObj[0], dStr[1], fp[2], dayElem[3], instance[4]
    onCalendarDayCreate(...params) {
        this.dayElem = params[3] || undefined;
        this.date = this.dayElem.getAttribute('aria-label');
        this.formatPrice = PriceFormatter(this.context).format;

        // set data-type
        this.dayElem.dataset.type = this.config.calendar.type.calendarDay;

        // set day with direct flight
        if (this.directFlight) this.setDayDirectFlight();

        if (this.disableDays) this.setDayDisable();

        return this;
    },
    // Set flight direct
    setDayDirectFlight() {
        const day = this.directFlight.find(item => item === this.date);

        if (day) {
            this.dayElem.classList.add(this.config.calendar.css.calendarDirectFlight);
        }

        return this;
    },
    // Set Direct direct
    setDirectFlights(directFlightDays) {
        const daySel = `${this.config.selector} [data-type="${this.config.calendar.type.calendarDay}"]`;
        this.directFlight = directFlightDays;

        [...document.querySelectorAll(daySel)].forEach(day => {
            this.dayElem = day;
            this.date = this.dayElem.getAttribute('aria-label');
            this.dayElem.classList.remove(this.config.calendar.css.calendarDirectFlight);
            this.setDayDirectFlight();
        });
    },
    setDayDisable() {
        const day = this.disableDays.find(item => item === this.date);

        if (day) {
            this.dayElem.classList.add(this.config.calendar.css.disabledDay, 'flatpickr-disabled');
        }

        return this;
    },
    setDisableDays: function Fn(disableDays) {
        const daySel = `[data-type="${this.config.calendar.type.calendarDay}"]`;

        this.disableDays = disableDays;
        [...document.querySelectorAll(daySel)].forEach(day => {
            this.dayElem = day;
            this.date = this.dayElem.getAttribute('aria-label');

            this.setDayDisable();
        });
    },
    // DisabletDaysCalendar
    disableDaysCalendar(instance) {
        if (instance.flightOperative.checkin.disableDays.length > 0) {
            instance.setDisableDays(instance.flightOperative.checkin.disableDays);
        }

        if (this.setDirectFlights.length > 0) {
            this.setDirectFlights(instance.flightOperative.checkin.directFlight);
        }

        instance.calendar.fp.redraw();
    },
    // OnChangeDaysCalendar
    onChangeDisableDaysCalendar(instance) {
        const calendarValues = instance.calendar.get();

        if (instance.flightOperative.checkin.disableDays.length > 0) {
            if (calendarValues.length === 1) {
                instance.setDisableDays(instance.flightOperative.checkout.disableDays);
            } else {
                instance.setDisableDays(instance.flightOperative.checkin.disableDays);
            }
        }

        if (this.setDirectFlights.length > 0) {
            if (calendarValues.length === 1) instance.setDirectFlights(instance.flightOperative.checkout.directFlight);
            else instance.setDirectFlights(instance.flightOperative.checkin.directFlight);
        }

        if (instance.flightOperative.checkin.disableDays.length > 0 || instance.setDirectFlights.length > 0)
            instance.calendar.fp.redraw();
    },
    setFooterCalendar(instance) {
        this.calendar.fp.calendarContainer.appendChild(toNode(instance.config.templateFooter)[0]);
        return this;
    },
    updateDestination(instance) {
        const destinationValue = instance.config.location.destination.value;
        if (destinationValue) {
            validationDestination(instance);
            suscriptionDates(instance);
        }
    }
};

// Exports
module.exports = prototype;
